module.exports = __webpack_public_path__ + "static/media/easily-customizable-website.80399db4.svg";